var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"primary",attrs:{"app":"","dark":""}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Logo","contain":"","src":require("../assets/logo.png"),"transition":"scale-transition","width":"60"}})],1),_c('h2',[_vm._v(" TruckMate ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }